var dateHelper = require("./date_helpers");

function copy(object) {
	var i, t, result; // iterator, types array, result

	if (object && typeof object == "object") {
		result = {};
		t = [Array,Number,String,Boolean];
		for (i=0; i<t.length; i++) {
			if (object instanceof t[i])
				result = i ? new t[i](object) : new t[i](); // first one is array
		}

		if (dateHelper.isDate(object)) {
			result = new Date(object);
		}

		for (i in object) {
			if (Object.prototype.hasOwnProperty.apply(object, [i]))
				result[i] = copy(object[i]);
		}
	}
	return result || object;
}

function mixin (target, source, force){
	for (var f in source)
		if ((!target[f] || force)) target[f]=source[f];
	return target;
}

function defined(obj) {
	return typeof(obj) != "undefined";
}

var seed;
function uid() {
	if (!seed)
		seed = (new Date()).valueOf();

	seed++;
	return seed;
}

//creates function with specified "this" pointer
function bind(functor, object){
	if(functor.bind)
		return functor.bind(object);
	else
		return function(){ return functor.apply(object,arguments); };
}

function event(el, event, handler){
	if (el.addEventListener)
		el.addEventListener(event, handler, false);

	else if (el.attachEvent)
		el.attachEvent("on"+event, handler);
}

function eventRemove(el, event, handler){
	if (el.removeEventListener)
		el.removeEventListener(event, handler, false);

	else if (el.detachEvent)
		el.detachEvent("on"+event, handler);
}


module.exports = {
	copy: copy,
	defined: defined,
	mixin: mixin,
	uid: uid,
	bind: bind,
	event: event,
	eventRemove: eventRemove
};


//////////////////
// WEBPACK FOOTER
// ./sources/utils/utils.js
// module id = 0
// module chunks = 0